import React from 'react'

// The page's own ground: one background image, and nothing else. The header bar and the content
// column are laid out inside it by SiteLayout, because a sticky bar that spans the page cannot
// live inside a centred column.
//
// 🔴 AND THE ABSTRACT LAYER. Measured in a real browser on 19 Sep 2026: NINE of the ten sites
// painted a soft gradient wash and nothing else, while nodejavascript.com painted a masked grid.
// George, that evening, verbatim: *"the only thing wrong is that the background image is not
// there for all sites except nodejavascript … the rest of the sites have lovely theme colours
// and gradients, but maybe missing the extra touch of a background abstract."* So every site
// gets its own geometry, and this one is concentric rings.
const Background = ({ children }) => (
  <div className='dvs-bg'>
    <div className='dvs-pattern' aria-hidden='true' />
    {children}
  </div>
)

export default Background
